/**
 * ÉCLAT FINE JEWELRY - FACETED FILTERS & COLLECTION REFINEMENTS
 */

class FacetedFilters {
  constructor() {
    this.form = document.querySelector('#CollectionFiltersForm');
    this.container = document.querySelector('#ProductGridContainer');
    this.init();
  }

  init() {
    if (!this.form) return;

    this.form.addEventListener('change', (e) => {
      this.applyFilters();
    });
  }

  async applyFilters() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;

    // Update browser URL history
    history.pushState({ searchParams }, '', url);

    try {
      if (this.container) {
        this.container.style.opacity = '0.5';
      }
      const res = await fetch(url);
      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newContainer = doc.querySelector('#ProductGridContainer');
      if (newContainer && this.container) {
        this.container.innerHTML = newContainer.innerHTML;
        this.container.style.opacity = '1';
      }
    } catch (err) {
      console.error('Error filtering products:', err);
      if (this.container) this.container.style.opacity = '1';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FacetedFilters();
});
